import {
  ConsumerFinancing,
  ProductRateRequest,
} from "./types/ConsumerFinancing";
import { DealFinancePricingRequest } from "./types/DealFinancePricingBreakdown";
import { ExtendedWarrantyRatesRequest } from "./types/ExtendedWarrantyRates";
import { VehicleFinancePricingRequest } from "./types/VehicleFinancePricingBreakdown";

const consumerFinancingQueryKeys = {
  all: ["consumerFinancing"] as const,
  consumerFinancing: () =>
    [...consumerFinancingQueryKeys.all, "consumer-financing"] as const,
  consumerFinancingById: (dealIds: string[]) =>
    [...consumerFinancingQueryKeys.all, "consumer-financing", dealIds] as const,
  consumerFinancingDocuments: (purchase: ConsumerFinancing | undefined) =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-documents",
      purchase?.id,
      purchase?.documentSummary.dealDocuments?.map((d) => d.id).join(","),
    ] as const,
  consumerFinancingCoverageProducts: () =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-coverage-products",
    ] as const,
  consumerFinancingTodos: (dealId: string) =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-todos",
      dealId,
    ] as const,
  consumerFinancingApplicationStatus: () =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-application-status",
    ] as const,
  consumerFinancingSubmissionApproval: (submissionId: string) =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-submission-approval",
      submissionId,
    ] as const,
  consumerFinancingSeller: () =>
    [...consumerFinancingQueryKeys.all, "consumer-financing-seller"] as const,
  consumerFinancingPricingDefaults: () =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-pricing-defaults",
    ] as const,
  consumerFinancingPricingBreakdown: (query: DealFinancePricingRequest) =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-pricing-breakdown",
      query,
    ] as const,
  consumerFinancingVehiclePricingBreakdown: (
    query: VehicleFinancePricingRequest
  ) =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-vehicle-pricing-breakdown",
      query,
    ] as const,
  consumerFinancingLenderPrograms: (dealId: string) =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-lender-programs",
      dealId,
    ] as const,
  consumerFinancingEligibleProvinces: () =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-eligible-provinces",
    ] as const,
  consumerFinancingExtWarrantyAllRates: () =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-ext-warranty-all-rates",
    ] as const,
  consumerFinancingExtWarrantyDefaultRates: (
    props: ExtendedWarrantyRatesRequest,
    locale: string
  ) =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-ext-warranty-default-rates",
      props,
      locale,
    ] as const,
  consumerFinancingProductPricingPreview: (props: ProductRateRequest) =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-product-pricing-preview",
      props,
    ] as const,
  consumerFinancingPayoutEmbedUrl: (dealId: string | null) =>
    [
      ...consumerFinancingQueryKeys.all,
      "consumer-financing-payout-embed-url",
      dealId,
    ] as const,
};

export default consumerFinancingQueryKeys;
